<button class="toggle-switch" (click)="onClick()" [disabled]="disabled">
    <input [disabled]="disabled" name="switch" type="checkbox" class="absolute top-0 left-0 invisible w-full h-full" [checked]="on" />
    <span class="relative flex-grow w-48 mr-24 bg-opacity-50 rounded-full h-18" [class]="on ? 'bg-primary-blue-400' : 'bg-gray-500'">
        <span class="absolute left-0 flex items-center justify-center w-24 h-24 transition duration-200 transform -translate-y-1/2 rounded-full shadow-sm top-1/2" [class]="on ? 'bg-primary-blue-500 translate-x-36' : 'bg-gray-300 -ml-10'">
        <i [ngClass]="{'mdi mdi-18px text-gray-800 text-opacity-75': !!icon}" [class]="icon ? icon : ''"></i>
        </span>
    </span>
    <ng-content for="switch"></ng-content>
</button>